import React from 'react';
import { Redirect, Switch } from 'react-router-dom';
import MetricGroupDetailsPageConnected from '../../../metrics/MetricGroupDetailsPageConnected/MetricGroupDetailsPageConnected';
import MetricsGroupsPageConnected from '../../../metrics/MetricGroupsPageConnected/MetricsGroupsPageConnected';
import ExploreMetricsPageConnected from '../../../metrics/ExploreMetricsPageConnected/ExploreMetricsPageConnected';
import RaaRoute from '../../../common/RaaRoute';

function MetricsPage() {
  /* istanbul ignore next */
  return (
    <Switch>
      <RaaRoute
        path="/s/sensor-data"
        exact
      >
        <Redirect to="/s/sensor-data/groups" />
      </RaaRoute>
      <RaaRoute
        path="/s/sensor-data/explore"
        exact
      >
        <ExploreMetricsPageConnected />
      </RaaRoute>
      <RaaRoute
        path="/s/sensor-data/explore/:channelKey"
        exact
        render={(routeProps) => {
          const { match: actionMatch } = routeProps;
          const { channelKey } = actionMatch.params;
          return (
            <ExploreMetricsPageConnected
              preSelectedChannelKey={channelKey}
            />
          );
        }}
      />
      <RaaRoute
        path="/s/sensor-data/groups"
        exact
      >
        <MetricsGroupsPageConnected />
      </RaaRoute>
      <RaaRoute
        path="/s/sensor-data/groups/:groupId"
        exact
        render={(routeProps) => {
          const { match: actionMatch } = routeProps;
          const groupId = parseInt(actionMatch.params.groupId, 10);
          return <MetricGroupDetailsPageConnected id={groupId} />;
        }}
      />
    </Switch>
  );
}

export default MetricsPage;
